// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1Htcw","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__cPsun"};